// app/frontend/relay-environment.ts
import { Environment, Network, RecordSource, Store } from "relay-runtime";
import { fetchRelay } from "./fetch-relay"; // Renamed this too, see below

// 1. Create the environment definition
function createEnvironment() {
  const source = new RecordSource();
  const store = new Store(source, { gcReleaseBufferSize: 10 });
  const network = Network.create(fetchRelay);

  return new Environment({
    network,
    store,
  });
}

// 2. Export a singleton instance for the app to use
export const environment = createEnvironment();

// 3. (Optional) Export a reset function if you need to clear the store on Logout
// In most apps, a hard window.location.reload() on logout is safer/easier.
export function resetEnvironment() {
  // This is where you might handle logic to clear the store
  // or return a fresh environment instance if needed.
}
